import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Publications.css';

const Publications = () => {
  const navigate = useNavigate();

  const publications = [
/*    {
      id: 'under-review',
      type: 'Articles under review',
      items: [
        {
          year: 2025,
          title: 'Sharing Neuroimaging Data in Compliance with GDPR: A Comprehensive Guide to Online Platforms and Procedures',
          authors: 'Lefort-Besnard J, Pron A, [...] (the GliMR WG2), Heunis Stephan, Maumet Camille',
        },
      ],
    },*/
    {
      id: 'peer-reviewed-journals',
      type: 'Published in peer-reviewed journals (Q1)',
      items: [
        {
          year: 2026,
          title: 'Structural MRI in the analytic multiverse: Consequences on discovery and predictive accuracy',
          authors: 'Delzant E, Lefort-Besnard J, Colliot O, Couvy-Duchesne B',
          journal: 'NeuroImage',
          links: [
            { label: 'DOI', url: 'https://doi.org/10.1016/j.neuroimage.2026.122272' },
          ],
        },
        {
          year: 2025,
          title: 'Which infrastructure can I use to share neuroimaging data? A survey and literature review on current solutions for EU researchers',
          authors: 'Lefort-Besnard J, Pron A, [...] (the GliMR WG2), Heunis S, Maumet C',
          journal: 'Aperture Neuro',
          links: [
            { label: 'PDF', url: 'https://inria.hal.science/hal-05071218v3' },
          ],
        },
        {
          year: 2025,
          title: 'Statistical Inference for Same Data Meta-Analysis for Neuroimaging Multiverse Analyzes',
          authors: 'Lefort-Besnard J, Nichols T, Maumet C',
          journal: 'Imaging Neuroscience',
          links: [
            { label: 'PDF', url: 'https://inria.hal.science/hal-04754078' },
            { label: 'CODES', url: 'https://github.com/Inria-Empenn/SDMA' },
            { label: 'TALK', url: 'https://www.youtube.com/watch?v=9BiRlP0Omsw' },
          ],
        },
        {
          year: 2023,
          title: 'Grey matter volume and CSF biomarkers predict neuropsychological subtypes of MCI',
          authors: 'Lefort-Besnard J, Naveau M, Delcroix N, Decker LM, Cignetti F',
          journal: 'Neurobiology of Aging',
          links: [
            { label: 'PDF', url: '../Images/Lefort-Besnard_et_al_2023_MCI_clusters.pdf' },
            { label: 'DOI', url: 'https://www.sciencedirect.com/science/article/abs/pii/S0197458023001471?via%3Dihub' },
            { label: 'CODES', url: 'https://github.com/JLefortBesnard/MCI_cluster_prediction' },
          ],
        },
        {
          year: 2022,
          title: 'Accurate machine learning prediction of sexual orientation based on brain morphology and intrinsic functional connectivity',
          authors: 'Lefort-Besnard J*, Clemens B*, Ritter C, Smith E, Votinov M, Derntl B, et al.',
          journal: 'Cerebral Cortex',
          links: [
            { label: 'PDF', url: '../Images/LefortBesnard2022_accurateML.pdf' },
            { label: 'DOI', url: 'https://academic.oup.com/cercor/article-abstract/33/7/4013/6698690?redirectedFrom=PDF' },
            { label: 'CODES', url: 'https://github.com/JLefortBesnard/SexualOrientation_2020' },
          ],
        },
        {
          year: 2021,
          title: 'Phenotypical predictors of pregnancy-related restless legs syndrome and their association with basal ganglia and the limbic circuits',
          authors: 'Chechko N, Lefort-Besnard J, Goecke TW, Frensch M, Schnakenberg P, Stickel S, et al.',
          journal: 'Scientific Reports',
          links: [
            { label: 'PDF', url: '../Images/Chechko2021_PhenotypicalRLS.pdf' },
            { label: 'DOI', url: 'https://www.nature.com/articles/s41598-021-89360-8' },
            { label: 'CODES', url: 'https://github.com/JLefortBesnard/RLS_2019' },
          ],
        },
        {
          year: 2020,
          title: 'Patterns of autism symptoms: hidden structure in the ADOS and ADI-R instruments',
          authors: 'Lefort-Besnard J, Vogeley K, Schilbach L, Varoquaux G, Thirion B, Dumas G, et al.',
          journal: 'Translational Psychiatry',
          links: [
            { label: 'PDF', url: '../Images/LefortBesnard2018_ASD.pdf' },
            { label: 'DOI', url: 'https://www.nature.com/articles/s41398-020-00946-8' },
            { label: 'CODES', url: 'https://github.com/JLefortBesnard/ADIR_ADOS2019' },
          ],
        },
        {
          year: 2019,
          title: 'What do parents of children with autism expect from participation in research? A community survey about early autism studies',
          authors: 'Fletcher-Watson S, Larsen K, Salomone E, Groups CEW',
          journal: 'Autism',
          links: [
            { label: 'PDF', url: '../Images/fletcher-watson-et-al-2017-what-do-parents.pdf' },
            { label: 'DOI', url: 'https://journals.sagepub.com/doi/10.1177/1362361317728436' },
          ],
        },
        {
          year: 2018,
          title: 'Patterns of schizophrenia symptoms: hidden structure in the PANSS questionnaire',
          authors: 'Lefort-Besnard J, Varoquaux G, Derntl B, Gruber O, Aleman A, Jardri R, et al.',
          journal: 'Translational Psychiatry',
          links: [
            { label: 'PDF', url: '../Images/Lefort-Besnard_et_al_2018_Panss.pdf' },
            { label: 'DOI', url: 'https://www.nature.com/articles/s41398-018-0294-4' },
            { label: 'CODES', url: 'https://github.com/JLefortBesnard/Panss2018' },
          ],
        },
        {
          year: 2018,
          title: 'Different shades of default mode disturbance in schizophrenia: Subnodal covariance estimation in structure and function',
          authors: 'Lefort-Besnard J, Bassett DS, Smallwood J, Margulies DS, Derntl B, Gruber O, et al.',
          journal: 'Human Brain Mapping',
          links: [
            { label: 'PDF', url: '../Images/LefortBesnard2018_DMN.pdf' },
            { label: 'DOI', url: 'https://onlinelibrary.wiley.com/doi/abs/10.1002/hbm.23870' },
          ],
        },
        {
          year: 2017,
          title: 'Attitudes of the autism community to early autism research',
          authors: 'Fletcher-Watson S, Apicella F, Auyeung B, Beranova S, Bonnet-Brilhault F, Canal-Bedia R, ... Lefort-Besnard J, ... et al.',
          journal: 'Autism',
          links: [
            { label: 'PDF', url: '../Images/FletcherWatson_2017_autism.pdf' },
            { label: 'DOI', url: 'https://journals.sagepub.com/doi/abs/10.1177/1362361315626577' },
          ],
        },
      ],
    },
    {
      id: 'conference-papers',
      type: 'Peer-reviewed conference papers (Q1)',
      items: [
        {
          year: 2020,
          title: 'Behavior score-embedded brain encoder network for improved classification of Alzheimer disease using resting state fMRI',
          authors: 'Lefort-Besnard J*, Hsieh WT*, Yang HC, Kuo LW, Lee CC',
          conference: '42nd Annual International Conference of the IEEE Engineering in Medicine & Biology Society (EMBC)',
          links: [
            { label: 'PDF', url: '../Images/LefortBesnard2020_BSEN.pdf' },
            { label: 'DOI', url: 'https://ieeexplore.ieee.org/document/9175312' },
            { label: 'CODES', url: 'https://github.com/JLefortBesnard/BSEN' },
          ],
        },
      ],
    },
    {
      id: 'posters',
      type: 'Peer reviewed conference: Accepted Posters',
      items: [
        {
          year: 2024,
          title: 'Statistical inference for same data meta-analysis for neuroimaging multiverse analyses',
          conference: 'OHBM',
          location: 'Seoul, South Korea 🇰🇷',
          links: [
            { label: 'PDF', url: 'https://inria.hal.science/hal-04474780v1/file/OHBM24_SDMA_Poster_jlb.pdf' },
          ],
        },
        {
          year: 2024,
          title: 'Revue et évaluation des méthodes de méta-analyse sur données corrélées pour l’analyse multivers',
          conference: 'IABM',
          location: 'Grenoble',
          links: [
            { label: 'PDF', url: 'https://inria.hal.science/hal-04296407' },
          ],
        },
        {
          year: 2023,
          title: 'Systematic review and benchmark of meta-analysis methods for same data test statistics',
          conference: 'Cogbases',
          location: 'Institut Pasteur Paris',
        },
        {
          year: 2022,
          title: 'Grey matter volume and CSF biomarkers predict neuropsychological subtypes of MCI',
          conference: 'OHBM',
          location: 'Glasgow, UK 🇬🇧',
        },
        {
          year: 2019,
          title: 'Improved Classification of Alzheimer Disease Using Resting State fMRI',
          conference: '42nd EMBC IEEE',
          location: 'Montreal, Canada 🇨🇦',
        },
        {
          year: 2019,
          title: 'Patterns of autism symptoms',
          conference: 'OHBM',
          location: 'Rome, Italy 🇮🇹',
        },
        {
          year: 2018,
          title: 'Patterns of Schizophrenia Symptoms in the PANSS Questionnaire',
          conference: 'OHBM',
          location: 'Singapore 🇸🇬',
        },
      ],
    },
    {
      id: 'talks',
      type: 'Peer reviewed conference: Accepted talks',
      items: [
        {
          year: 2024,
          title: 'Systematic review and evaluation of meta-analysis methods for same data meta-analyses',
          conference: 'OHBM',
          location: 'Seoul, South Korea 🇰🇷',
          links: [
            { label: 'Link OHBM24', url: 'https://ww6.aievolution.com/hbm2401/index.cfm?do=ev.viewEv&ev=1259' },
            { label: 'Link YouTube', url: 'https://www.youtube.com/watch?v=9BiRlP0Omsw' },
          ],
        },
        {
          year: 2023,
          title: 'The Narps Open Pipeline Project',
          conference: 'OpenNeuroWorkshop',
          location: 'ICM, Paris',
        },
        {
          year: 2023,
          title: 'Future of Meta-Analysis',
          conference: 'Cogbases',
          location: 'Institut Pasteur, Paris',
        },
        {
          year: 2023,
          title: 'Data sharing in Europe: reviewing current practices',
          conference: 'GliMR 2.0',
          location: 'Porto, Portugal 🇵🇹',
        },
      ],
    },
  ];
  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="background">

    <div className="main-container">
      <nav className="navbar">
        <button className="home-button" onClick={handleGoHome}>
          ← Back home
        </button>
        <div className="toc">
          <ul>
            {publications.map((section) => (
              <li key={section.id}>
                <a href={`#${section.id}`}>{section.type}</a>
              </li>
            ))}
          </ul>
        </div>
      </nav>
      <div className="publications-container">
      {publications.map((section) => (
        <div key={section.id} id={section.id} className="publication-section">
          <h2>{section.type}</h2>
          <div className="pub-list">
            {section.items.map((item, itemIndex) => (
              <div key={itemIndex} className="pub-card">
                <div className="pub-card-head">
                  <b>{item.title}</b>
                  <span className="year-tag">{item.year}</span>
                </div>
                {item.authors && <p className="pub-meta">{item.authors}</p>}
                {item.journal && <p className="pub-meta pub-meta-italic">{item.journal}</p>}
                {item.conference && <p className="pub-meta pub-meta-italic">{item.conference}</p>}
                {item.location && <p className="pub-meta pub-meta-italic">{item.location}</p>}
                {item.links && (
                  <div className="pub-links">
                    {item.links.map((link, linkIndex) => (
                      <a key={linkIndex} href={link.url} target="_blank" rel="noopener noreferrer">
                        {link.label}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
      </div>
    </div>
  </div>

  );
};

export default Publications;
